// ShogiApp.jsx
// Router: her sayfa iki adreste yayınlanır — Türkçe kökte (/oyna), İngilizce /en altında
// (/en/play). Eşlemeler src/i18n/routes.json'da.

import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import alertify from '../lib/alertifySetup';
import { AuthProvider } from '../context/AuthContext';
import { logAnalyticsEvent } from '../firebase';
import { ROUTES, LANGS, useLang } from '../i18n';

import Navbar from './Navbar';
import Footer from './Footer';
import AppInstallBanner from './AppInstallBanner';
import HomePage from '../pages/HomePage';
import HowToPlayPage from '../pages/HowToPlayPage';
import PiecesPage from '../pages/PiecesPage';
import RulesPage from '../pages/RulesPage';
import PlayPage from '../pages/PlayPage';
import PuzzlesPage from '../pages/PuzzlesPage';
import PuzzlePage from '../pages/PuzzlePage';
import ProfilePage from '../pages/ProfilePage';
import LeaderboardPage from '../pages/LeaderboardPage';
import AcademyPage from '../pages/AcademyPage';
import ArenaPage from '../pages/ArenaPage';
import ContactPage from '../pages/ContactPage';
import FaqPage from '../pages/FaqPage';
import AppsPage from '../pages/AppsPage';

const PAGES = {
  home: HomePage,
  play: PlayPage,
  puzzles: PuzzlesPage,
  puzzle: PuzzlePage,
  arena: ArenaPage,
  academy: AcademyPage,
  howto: HowToPlayPage,
  pieces: PiecesPage,
  rules: RulesPage,
  faq: FaqPage,
  apps: AppsPage,
  leaderboard: LeaderboardPage,
  contact: ContactPage,
  profile: ProfilePage,
};

function SiteEffects() {
  const { pathname } = useLocation();
  const { lang, t } = useLang();

  useEffect(() => {
    logAnalyticsEvent('page_view', { page_path: pathname, page_title: document.title, language: lang });
    window.scrollTo(0, 0);
  }, [pathname, lang]);

  useEffect(() => {
    alertify.defaults.glossary.ok = t('common.yes');
    alertify.defaults.glossary.cancel = t('common.no');
  }, [t]);

  return null;
}

function NotFound() {
  const { to } = useLang();
  return <Navigate to={to('home')} replace />;
}

export default function ShogiApp() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <SiteEffects />
          <div className="d-flex flex-column min-vh-100">
            <Navbar />
            <main className="flex-grow-1">
              <Routes>
                {Object.entries(PAGES).flatMap(([key, Page]) =>
                  LANGS.map((lang) => <Route key={`${key}-${lang}`} path={ROUTES[key][lang]} element={<Page />} />)
                )}
                {/* Eski adres: İngilizce SSS artık /en/faq */}
                <Route path="/faq" element={<Navigate to="/en/faq" replace />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
            <AppInstallBanner />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}
